<template>
  <div class="Information">
    <el-badge :max="99" class="item" :value="$store.state.workFlow.upcoming" :hidden="$store.state.workFlow.upcoming===0">
      <el-button type="text" @click="handleTodoWorkFlow">
        <svg-icon icon-class="todo-wf" :color="textColor"></svg-icon>
      </el-button>
    </el-badge>  
    <el-badge :max="99" class="item" :value="$store.state.workFlow.warning" style="margin:0 12px" :hidden="$store.state.workFlow.warning===0">
      <el-button type="text" @click="getWarningList">
        <svg-icon icon-class="warning" :color="textColor"></svg-icon>
      </el-button>
    </el-badge>     
    <el-badge :max="99" :value="$store.state.workFlow.message" style="margin-right:4px" class="item" :hidden="$store.state.workFlow.message===0">
      <el-button type="text" @click="handleMsg(0)">
        <svg-icon icon-class="information" :color="textColor"></svg-icon>
      </el-button>
    </el-badge>    
    <!-- 预警预览 -->
    <Drawer 
      class="inside information-inside"
      :title="$t('dialogTitle.warnings')"
      v-model="dropVisible">
      <div v-loading="loading" style="padding:0 15px;">
        <div style="padding-top:30vh;text-align:center;" v-if="!warningData.length">{{$t('status.noWarning')}}</div>
        <el-row 
          v-for="(item) in warningData" 
          :key="item.id" 
          v-else 
          style="cursor:pointer"
          :class="'warningRow'" 
          @click.native="getCurrentWarning(item)">
          <el-col class="time">{{parseTime(item.sendTime,'{y}-{m}-{d} {h}:{i}')}}</el-col>
          <el-col class="text">{{item.content}}</el-col>
        </el-row>
      </div>
    </Drawer>
    <!-- 消息 -->
    <el-dialog
      append-to-body
      class="message-dialog"
      :show-close="false"
      :visible.sync="dialogVisible"
      width="800px">
      <div class="toolBar">
        <el-tabs v-model="messageStatus" @tab-click="filterChange">
          <el-tab-pane :label="$t('buttons.unread')" name="0"></el-tab-pane>
          <el-tab-pane :label="$t('buttons.read')" name="1"></el-tab-pane>
          <!-- <el-tab-pane :label="$t('buttons.all')" name="null"></el-tab-pane> -->
        </el-tabs>
        <div class="delete">
          <span style="float:left;margin-top:8px;" v-if="multipleSelection.length&&selectModel">
            {{$t('buttons.total')}}{{$t('buttons.choosed')}}{{multipleSelection.length}}{{$t('buttons.num')}}
          </span>
          <el-checkbox 
            v-if="selectModel"
            :indeterminate="isIndeterminate" 
            v-model="checkAll" 
            @change="handleCheckAllChange">
          </el-checkbox>
          <el-button type="text" size="medium" @click="()=>selectModel=!selectModel">{{selectModel?$t('buttons.cancel'):$t('buttons.batch')}}</el-button>
          <el-button type="text" :disabled="!selectModel||!multipleSelection.length" size="medium" @click="handelDeleteGroup">{{$t('buttons.delete')}}</el-button>
        </div>
      </div>
      <div v-loading="loading" style="height:50vh;overflow:hidden;">
        <el-scrollbar>
          <div style="height:50vh;padding:5px 0">
            <div style="padding:20% 0;text-align:center;" v-if="!gridData.length">{{$t('status.noMsg')}}</div> 
            <el-checkbox-group v-model="multipleSelection" v-else>
              <div v-for="(item) in gridData" :key="item.id" style="padding:0 15px;">
                <el-card shadow="hover" @click.native="handleStatus(item)" class="item-card">
                  <el-button size="medium" class="delete" icon="el-icon-error" type="text" @click.prevent.stop="handleDelete(item)"/>
                  <div style="width:100%;padding-bottom:10px">
                    <span class="dot" :style="{'background':theme.main}" v-if="!selectModel"></span>
                    <el-checkbox class="item-checkbox" :label="item.id" v-if="selectModel">&nbsp;</el-checkbox>
                    <span class="time" style="display:inline-block;margin-right:20px;color:#b3b3b3">{{item.senderName}}</span>  
                    <span class="time" style="color:#b3b3b3">{{parseTime(item.sendTime,'{y}-{m}-{d} {h}:{i}')}}</span>  
                    <span style="display:inline-block;margin-left:20px;color:#ccc;font-size:12px" v-if="item.status">{{$t('buttons.read')}}</span>
                  </div>
                  <p>{{formatFilter(item.content)}}</p>
                  <div class="toolBar">
                    <el-button @click.stop.prevent="handleCheckTemplate(item)" icon="el-icon-view" type="text"></el-button> 
                    <el-button @click.stop.prevent="handleConnect(item)" icon="el-icon-edit-outline" type="text"></el-button> 
                  </div>
                </el-card>
              </div>
            </el-checkbox-group>
          </div>
        </el-scrollbar>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-pagination          
          background
          :current-page="listQuery.pageIndex"
          :page-sizes="[10,20, 30, 50, 100]"
          :page-size="listQuery.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange">
        </el-pagination>  
      </span>
    </el-dialog>
    <!-- <Drawer 
      class="inside information-inside message"
      :title="$t('dialogTitle.messages')"
      v-model="dialogVisible">
      <div class="toolBar">
        <el-tabs v-model="messageStatus" @tab-click="filterChange">
          <el-tab-pane :label="$t('buttons.unread')" name="0"></el-tab-pane>
          <el-tab-pane :label="$t('buttons.read')" name="1"></el-tab-pane>
          <el-tab-pane :label="$t('buttons.all')" name="null"></el-tab-pane>
        </el-tabs>
        <div class="delete">
          <el-checkbox 
            v-if="hasSelect" 
            :indeterminate="isIndeterminate" 
            v-model="checkAll" 
            @change="handleCheckAllChange">
          </el-checkbox>
          <el-button type="text" :icon="multipleSelection.length||!hasSelect?'el-icon-delete':'el-icon-close'" size="medium" @click="handelDeleteGroup"></el-button>
        </div>
      </div>
      <div v-loading="loading" style="height:calc(100% - 47px);overflow:hidden;">
        <div style="padding-top:30vh;text-align:center;" v-if="!gridData.length">{{$t('status.noMsg')}}</div> 
          <el-scrollbar v-else style="height:calc(100% + 32px);">
            <div>
              <el-checkbox-group v-model="multipleSelection">
                <div v-for="(item) in gridData" :key="item.id" style="padding:0 15px;">
                  <div>
                    <span class="time" style="display:inline-block;margin-right:10px;color:#666">{{parseTime(item.sendTime,'{y}-{m}-{d} {h}:{i}')}}</span>
                    <span class="sender" style="color:#666">{{item.senderName}}</span>  
                  </div>
                  <el-row type="flex" class="row-bg" justify="space-between">
                    <el-col :span="2" v-if="hasSelect">
                      <el-checkbox :label="item.id"></el-checkbox>    
                    </el-col>
                    <el-col :span="hasSelect?22:24">
                      <el-card shadow="never" @click.native="handleStatus(item)">                                    
                        <el-button size="medium" class="delete" icon="el-icon-circle-close" type="text" @click.prevent.stop="handleDelete(item)"/>
                        <p v-if="item.showAll" :style="item.status?`color:#666`:''">{{formatFilter(item.content)}}</p>
                        <p v-else :style="item.status?`color:#666`:''">
                          {{formatFilter(item.content).substring(0,26)+(item.content.length>26?'...':'')}}
                        </p>
                        <div class="toolBar">
                          <el-button @click.stop.prevent="handleCheckTemplate(item)" icon="el-icon-view" type="text"></el-button> 
                          <el-button @click.stop.prevent="handleConnect(item)" icon="el-icon-edit-outline" type="text"></el-button> 
                        </div>                  
                      </el-card>
                    </el-col>
                  </el-row>
                  
                  
                </div>
              </el-checkbox-group>
            </div>
          </el-scrollbar>
      </div>      
      <el-pagination          
        :current-page="listQuery.pageIndex"
        :page-sizes="[10, 30, 50, 100]"
        :page-size="listQuery.pageSize"
        layout="prev,next"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange">
      </el-pagination>      
    </Drawer> -->
    <!-- 预警 -->
    <el-dialog
      class="informationDialog"
      v-el-drag-dialog :title="`${$t('dialogTitle.warnings')} (${$t('buttons.total')}${warningTableData.length}${$t('buttons.num')})`" 
      append-to-body
      width="40%"
      :visible.sync="warningDialigVisible">
      <el-table 
        width="100%"
        :data="warningTableData" 
        height="400"
        stripe
        border
        v-loading="warningDialigLoading">
        <el-table-column
          type="index"
          width="50"
          :label="$t('table.SN')"
          align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(value, key,index) of warningTableData[0]" 
          :key="index" align="center" 
          :prop="key" 
          :label="key">
        </el-table-column>
      </el-table>
      <div slot="footer" style="text-align:center">
        <el-button @click="warningDialigVisible = false">关 闭</el-button>
        <el-button :loading="downloadLoading" type="primary" @click="handleDownload">下 载</el-button>
      </div>
    </el-dialog>
    <!-- 查看 -->
    <Drawer 
      class="checkDrawer"
      :width="maximization?maxWidth:'50'"
      v-model="checkVisible">
        <div slot="header" class="ivu-drawer-header-inner">
          <span>{{checkTitle}}-{{$t('buttons.check')}}</span>
          <svg-icon icon-class="maximization" class="maximization" @click.native="handleMaximization"/>
        </div>
        <p v-if="currentMessage" class="currentMessage">{{formatFilter(currentMessage)}}</p>
        <report-editor 
          style="height: calc(100% - 50px);"
          :useRouter="false"
          :formEditStatus="50"
          v-loading="popoverLoading"
          ref='reportEditor'>
        </report-editor>
    </Drawer>
    <!-- dialog表单 -->
    <report-dialog 
      :connectProps="connectProps"
      :dataRow="dataRow"
      :model="model"
      :reportDialogVisible="reportDialogVisible"
      @reportDialogClose="reportDialogVisible=false"/>      
  </div>  
</template>

<script>
import { getWorkFlowTableData, getNotifications } from '@/api/workFlow'
import ReportDialog from '@/components/ReportDialog/index.vue'
import handleSheet from '@/views/WorkFlow/mixins/handleSheet'
import { parseTime, downloadFile } from '@/utils'
import { getMessages, patchMessage, deleteMessage, getCurrentWarning, getMessage, getMessageOutPut, exportWarning } from '@/api/information'
import { mapGetters } from 'vuex'
import notification from '@/notification.js'
export default {
  mixins: [notification, handleSheet],
  name: 'Information',
  components: {
    ReportDialog
  },
  computed: {
    ...mapGetters([
      'textColor',
      'theme'
    ]),
    isIndeterminate() {
      const a = new Set(this.multipleSelection)
      const b = new Set(this.gridData.map(l => l.id))
      const intersectionSet = new Set([...a].filter(x => b.has(x)))
      const arr = Array.from(intersectionSet)
      return arr.length > 0 && arr.length < this.gridData.length && this.gridData.length > 0
    },
    checkAll: {
      get: function() {
        const a = new Set(this.multipleSelection)
        const b = new Set(this.gridData.map(l => l.id))
        const intersectionSet = new Set([...a].filter(x => b.has(x)))
        const arr = Array.from(intersectionSet)
        return arr.length === this.gridData.length && this.gridData.length > 0
      },
      set: function(newValue) {
        return newValue
      }
    }
  },
  data() {
    return {
      downloadLoading: false,
      warningId: 0,
      multipleSelection: [],
      hasSelect: false,
      checkTitle: '',
      reportDialogVisible: false,
      connectProps: {},
      dataRow: {},
      model: 0,
      currentMessage: '',
      parseTime: parseTime,
      warningData: [],
      warningDialigLoading: false,
      warningTableData: [],
      warningDialigVisible: false,
      dropVisible: false,
      hasWarning: false,
      loading: false,
      listQuery: {
        type: 0, // 0:info 1:warning
        pageIndex: 1,
        pageSize: 10,
        filter: '',
        sort: '',
        status: 0,
        receiver: this.$store.getters.userId
      },
      total: 0,
      hideDot: true,
      gridData: [],
      dialogVisible: false,
      messageStatus: 0,
      selectModel: false
    }
  },
  created() {
    this.getNotifications()
    getMessages({ type: 0, status: 0, pageSize: 1, receiver: this.$store.getters.userId }).then(response => {
      this.hideDot = response.data.total === 0
    })
    getWorkFlowTableData({
      type: 'upcoming',
      pageIndex: 1,
      pageSize: 100 }).then(response => {
      this.$store.dispatch('changeHasTodo', response.data.length !== 0)
    })
  },
  watch: {    
    dialogVisible(newVal) {
      if (!newVal) {
        this.getNotifications()
      }
    },
    '$store.state.workFlow.topStamp'(newVal, oldVal) {
      const time = newVal - oldVal
      if (time > 5) {
        this.getNotifications()
      }
    },
    dropVisible(newVal) {
      if (newVal) {
        document.onkeyup = e => {
          if (e.keyCode === 27) {
            this.dropVisible = false
          }
        }
      } else {
        document.onkeyup = null
        this.getNotifications()
      }
    }
  },
  methods: {
    handleDownload() {
      this.downloadLoading = true
      exportWarning(this.warningId).then(response=>{
        const filename = `预警_${new Date().getTime()}.xlsx`
        downloadFile(response.data, filename)
        this.downloadLoading = false
      }).catch(()=>{
        this.downloadLoading = false
      })
    },
    getNotifications() {
      getNotifications(this.$store.getters.userId).then(response => {
        Object.keys(response.data).forEach(key => {
          this.$store.dispatch('changeState', {
            key: key,
            value: response.data[key]
          })
        })
      })
    },
    handelDeleteGroup() {
      if (this.multipleSelection.length) {
        this.$confirm(`${this.$t('alert.batchDeleteBefore')}${this.multipleSelection.length}${this.$t('alert.batchDeleteAfter')}`, this.$t('status.warning'), {
          confirmButtonText: this.$t('buttons.confirm'),
          cancelButtonText: this.$t('buttons.cancel'),
          type: 'warning',
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              instance.confirmButtonLoading = true
              const arr = this.multipleSelection
              deleteMessage(arr).then(response => {
                instance.confirmButtonLoading = false
                done()
                this.$message({
                  message: this.$t('alert.deleteSuccess'),
                  type: 'success',
                  duration: 3000
                })
                this.multipleSelection = []
                this.getMessages()
              }).catch(() => {
                instance.confirmButtonLoading = false
                done()
              })
            } else {
              done()
            }
          }
        }).catch(() => {})
      } else {
        this.hasSelect = !this.hasSelect
      }
    },
    handleCheckAllChange(val) {
      const arr = this.gridData.map(t => { return t.id })
      if (val) {
        this.multipleSelection = Array.from(new Set([...this.multipleSelection, ...arr]))
      } else {
        arr.forEach(a => {
          this.multipleSelection.splice(this.multipleSelection.indexOf(a), 1)
        })
      }
    },
    handleTodoWorkFlow() {
      this.$store.dispatch('changeCurrentType', 1)
      this.$store.dispatch('changeHasTodo', false)
      const routerTemp = {
        name: this.$t('workflow.workflow'),
        nodeId: `workflow-0`,
        templateId: 0,
        routeType: 'workflow',
        model: 0,
        path: `/workFlow`
      }
      this.$router.push(routerTemp.path)
      this.$store.dispatch('SetLastTab', routerTemp)
      this.$store.dispatch('addView', routerTemp)
    },
    // 关联填报
    handleConnect(item) {
      getMessage(item.id).then(current => {
        if (current.data.templateId) {
          getMessageOutPut(current.data.id).then(response => {
            sessionStorage.setItem('connectParams', JSON.stringify(response.data[0]))
            if (current.data.targetMode === null) {
              const routerTemp = {
                name: `${current.data.templateName}-${this.$t('buttons.create')}`,
                nodeId: `create-${current.data.templateId}`,
                templateId: current.data.templateId,
                routeType: 'create',
                model: 0,
                path: `/report/${current.data.templateId}/0`
              }
              this.$router.push(routerTemp.path)
              this.$store.dispatch('SetLastTab', routerTemp)
              this.$store.dispatch('addView', routerTemp)
            } else {
              this.dataRow = {
                templateId: current.data.templateId,
                recordId: 0
              }
              this.model = 0
              this.reportDialogVisible = true
            }
          })
        } else {
          this.$message(this.$t('alert.notBoundAssociated'))
        }
      })
    },
    // 查看
    handleCheckTemplate(item) {
      this.handleStatus(item)
      getMessage(item.id).then(response => {
        if (response.data.triggerTemplateId) {
          this.checkTitle = response.data.triggerTemplateName
          const dataRow = {
            templateId: response.data.triggerTemplateId,
            rid: response.data.recordId
          }
          this.currentMessage = response.data.content
          this.handleCheck(dataRow)
        } else {
          this.handleStatus(item)
          this.$message(this.$t('alert.notBoundView'))
        }
      })
    },
    formatFilter(str) {
      if (str !== '' && str !== null && str !== undefined) {
        return str.replace(/<p>/g, '').replace(/<\/p>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&amp;/g, '&').replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/<br \/>/g, '').replace(/&nbsp;/g, ' ')
      }
    },
    getCurrentWarning(data) {
      if (data.recordId === 0) return
      this.warningId = data.recordId
      this.warningDialigVisible = true
      this.warningDialigLoading = true
      getCurrentWarning(data.recordId).then(response => {
        this.warningTableData = response.data
        this.warningDialigLoading = false
      }).catch(() => {
        this.warningTableData = []
        this.warningDialigLoading = false
      })
    },
    getWarningList() {
      this.resetQuery()
      this.listQuery.type = 1
      this.listQuery.status = null
      this.dropVisible = !this.dropVisible
      this.$nextTick(() => {
        if (this.dropVisible) {
          this.$notify.closeAll()
          this.hasWarning = false
          this.loading = true
          getMessages(this.listQuery).then(response => {
            this.warningData = response.data.data
            this.loading = false
          })
        }
      })
    },
    DateTime(row, column, cellValue, index) {
      return parseTime(new Date(cellValue), '{y}-{m}-{d} {h}:{i}')
    },
    // 删除消息
    handleDelete(row) {
      this.$confirm(this.$t('alert.deleteMsg'), this.$t('status.warning'), {
        confirmButtonText: this.$t('buttons.confirm'),
        cancelButtonText: this.$t('buttons.cancel'),
        type: 'warning'
      }).then(() => {
        const list = [row.id]
        deleteMessage(list).then(() => {
          this.getMessages()
        })
      }).catch(() => {
        return false
      })
    },
    // 删除搜索内容
    handleDeleteSearch(val) {
      if (val === '') {
        this.getMessages()
      }
    },
    // 排序
    sortChange(val) {
      const prop = val.prop !== null ? val.prop.split('-')[1] || val.prop : null
      const sort = val.order !== null ? `${prop}|${val.order.substring(0, val.order.length - 6)}` : this.defaultSort
      this.listQuery.sort = sort
      this.getMessages()
    },
    handleSizeChange(val) {
      this.listQuery.pageSize = val
      this.getMessages()
    },
    handleCurrentChange(val) {
      this.listQuery.pageIndex = val
      this.getMessages()
    },
    resetQuery() {
      this.listQuery.pageIndex = 1
      this.listQuery.pageSize = 10
      this.listQuery.filter = ''
      this.listQuery.sort = ''
    },
    getMessages() {
      this.loading = true
      getMessages(this.listQuery).then(response => {
        this.gridData = response.data.data
        this.gridData.forEach(g => {
          this.$set(g, 'showAll', false)
        })
        this.total = response.data.total
        this.loading = false
      })
    },
    // 改变消息状态
    handleStatus(row) {
      row.showAll = !row.showAll
      this.$nextTick(() => {
        if (row.status === 0 && (this.listQuery.status === 0 || this.listQuery.status === null)) {
          const patch = [
            {
              'value': 1,
              'path': '/Status',
              'op': 'replace'
            }
          ]
          patchMessage(row.id, patch).then(() => {
            row.status = 1
          }).catch(() => {
            row.status = 0
          })
        }
      })
    },
    filterChange() {
      this.resetQuery()
      this.listQuery.status = this.messageStatus === 'null' ? null : this.messageStatus
      this.getMessages()
    },
    handleMsg(type) {
      this.$notify.closeAll()
      this.resetQuery()
      this.messageStatus = '0'
      this.listQuery.status = 0
      this.dialogVisible = true
      this.listQuery.type = type
      this.getMessages()
      this.$nextTick(() => {
        this.hideDot = true
      })
    }
  }
}
</script>
<style lang="scss">
  .message-dialog{
    .el-dialog__header{
      display: none;
    }
    .el-dialog__body{
      // padding-top: 0 !important;
    }
    .toolBar{
      margin-bottom: 0;
      position: relative;
      .el-tabs__item{
        // padding:0 12px;
      }
      >span{
        float: left;
      }
      .el-checkbox{
        float: left;
        margin-top: 7.5px;
        margin-right: 20px;
        margin-left: 25px;
      }
      .delete{
        position: absolute;
        right: 0px;
        top:2px;
      }
    }  
    .el-card{
      margin-top: 5px;
      margin-bottom: 15px;
      overflow: visible;
      .time{
        color:#666;
        font-size: 14px;
      }
      .dot{
        display: inline-block;
        width: 10px;
        height: 10px;
        margin-right: 10px;
        border-radius: 50%
      }
      .item-checkbox{
        width: 20px;
        height: 15px;
        .el-checkbox__input{
          margin-top: -3px;
        }
      }
      .text{
        color:#666;
        font-size: 16px;
      }
      .el-card__body{
        padding: 12px 20px;
        transition: 0.3s;
        position: relative;
        // .el-checkbox{
        //   top:0px;
        //   left:5px;
        //   position: absolute;
        // }
        .toolBar{
          position: absolute;
          right: 10px;
          top: 17px;
          margin: 0;
          display: none;
          .el-button{
            padding: 0;
            margin: 0;
            font-size: 16px;
            margin-left: 5px;
          }
        }
        .updown{
          width: 100%;
          position: absolute;
          bottom: -1px;
          left: 0;
          padding:0;
          text-align: center;
        }
        .delete{
          position: absolute;
          top: -16px;
          right: -8px;
          display: none;
        }
        p{
          font-size: 14px;
        }        
      }
    }
    .el-card__body:hover .delete{
      display: block;
    } 
    .el-card__body:hover .toolBar{
      display: block;
    }  
  }
  .information-inside.message{
    // .el-checkbox__label{
    //   display: none;
    // }
    .toolBar{
      position: relative;
      .el-tabs__item{
        // padding:0 12px;
      }
      // .el-checkbox{
      //   margin-top: 7.5px;
      //   margin-right: 5px;
      //   float: left;
      // }
      .delete{
        position: absolute;
        right: 15px;
        top:2px;
      }
    }    
  }
  .checkDrawer{
    .ivu-drawer{
      transition: 0.3s;
    }
    .ivu-drawer-wrap, .ivu-drawer-mask{
      z-index: 3000 !important;
    }
    .currentMessage{
      font-size: 14px;
      margin-bottom: 15px;
      color:#666;
      padding-left: 20px;
    }
  }
  .information-inside{    
    .el-tabs__header{
      margin: 0;
      padding: 0 15px;
      margin-top: -15px;
    }
    .el-card{
      width: 97%;
      margin-top: 3px;
      margin-bottom: 15px;
      overflow: visible;
      .el-card__body{
        transition: 0.3s;
        padding:5px 10px;
        position: relative;
        .toolBar{
          position: absolute;
          right: 5px;
          bottom: 0;
          margin: 0;
          .el-button{
            padding: 0;
            margin: 0;
          }
        }
        .updown{
          width: 100%;
          position: absolute;
          bottom: -1px;
          left: 0;
          padding:0;
          text-align: center;
        }
        .delete{
          position: absolute;
          top: -16px;
          right: -8px;
          display: none;
        }
        p{
          font-size: 14px;
        }        
      }
    }
    .el-card__body:hover .delete{
      display: block;
    }
    .el-pagination{
      background: #fff;
      text-align:center;
      position: absolute;
      bottom: -12px;
      left:0;
      width: 100%;
    }
    .ivu-drawer-body{
      padding:15px 0;
      position: relative;
      .time{
        color:#666;
        font-size: 14px;        
      }
      .text{
        color:#666;
        font-size: 16px;
      }
    }
  }
  .warningRow{
    cursor: pointer;
    padding-bottom: 10px;
    margin-bottom: 10px;
    border-bottom: 1px solid #ebeef5;
  }
  .Information{
    float: right;
    margin-right: 10px;
    .el-badge__content{
      border:0 solid #FFF;
      background-color: #ff3b30;
    }
    .el-badge__content.is-fixed{
      top:15px;
      right:9px !important;
    }
    .svg-icon{
      width: 18px !important;
      height: 18px !important;
      margin-right: 0 !important;
    }
  }
  .informationDialog{
    .el-dialog__body{
      padding:12px 20px !important;
    }
    .el-pagination{
      text-align: right;
      padding-top: 15px;
      padding-right: 0;
      // border-left: 1px solid #ebeef5;
      // border-right: 1px solid #ebeef5;
      // border-bottom: 1px solid #ebeef5;
      .el-pagination__sizes{
        margin-right: 0;
        .el-input{
          margin-right: 0;
        }
      }
      
    }
    .toolBar{
      overflow: hidden;  
      .el-form-item{
        margin-bottom: 0;
      }
      .searchBar{
        float: right;
      }
    }
  }
</style>
